import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: "confirmation" }
const _hoisted_3 = { class: "flex items-center mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!
  const _component_WebApiMessage = _resolveComponent("WebApiMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ProfileInfoItem = _resolveComponent("ProfileInfoItem")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, {
            name: "o-anim-fade-500",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.showConfirmation)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.labels.setNewPasswordConfirmation), 1))
                : (_openBlock(), _createBlock(_component_Form, {
                    key: "form",
                    "validation-schema": _ctx.formValidation,
                    class: "mt-30",
                    onSubmit: _ctx.submit
                  }, {
                    default: _withCtx(({ isSubmitting }) => [
                      _createVNode(_component_InputText, {
                        name: "password",
                        label: _ctx.labels.oldPasswordLabel,
                        type: "password",
                        "input-clear": false,
                        autocomplete: "new-password"
                      }, null, 8, ["label"]),
                      _createVNode(_component_InputText, {
                        name: "newPassword",
                        label: _ctx.labels.newPasswordLabel,
                        type: "password",
                        "input-clear": false,
                        autocomplete: "new-password"
                      }, null, 8, ["label"]),
                      _createVNode(_component_InputText, {
                        name: "newPasswordConfirm",
                        label: _ctx.labels.repeatNewPasswordLabel,
                        type: "password",
                        "input-clear": false,
                        autocomplete: "new-password"
                      }, null, 8, ["label"]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-dusty-grey c-magic-line mr-40",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearEditMode && _ctx.clearEditMode(...args)), ["prevent"]))
                        }, _toDisplayString(_ctx.labels.cancelSetNewPasswordButton), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_ConfirmationButton, {
                            class: "w-full",
                            confirm: isSubmitting,
                            "animation-duration": _ctx.confirmationAnimationTiming,
                            text: _ctx.labels.setNewPasswordButton,
                            "confirmation-text": _ctx.labels.setNewPasswordButtonPending
                          }, null, 8, ["confirm", "animation-duration", "text", "confirmation-text"])
                        ])
                      ]),
                      _createVNode(_component_WebApiMessage, {
                        id: _ctx.changeUserPasswordWebApiMessageKey,
                        class: "w-full text-center mt-20 mb-5"
                      }, null, 8, ["id"])
                    ]),
                    _: 1
                  }, 8, ["validation-schema", "onSubmit"]))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_ProfileInfoItem, {
          key: 1,
          title: _ctx.labels.passwordLabel
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "text-dusty-grey c-magic-line",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setEditMode && _ctx.setEditMode(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.labels.changePasswordButton), 1)
          ]),
          _: 1
        }, 8, ["title"]))
  ]))
}